import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { UserService } from '@shared/modules/account/services/user.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanLoad {
  constructor(private userService: UserService, private router: Router) { }

  canActivate(): boolean {
    return this.userService.isAdmin();
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    const isAdmin = this.userService.isAdmin()
    
    !isAdmin && this.router.navigate([""]);

    return isAdmin;
  }
}
